/* esm.sh - applesauce-core@5.2.0/dist/operations/tag/common */
export * from "/*applesauce-core@5.2.0/esnext/dist/operations/tag/common.mjs";
